<template>
  <div>
    <el-dialog class="homeLogin" :title="$t('lang.登录')" :visible.sync="visible" :show-close="false" :width="loginWidth" :close-on-click-modal="false" :close-on-press-escape="false">
      <!-- 掉线后登录的弹窗 -->
      <div class="dialog-login">
        <div class="dialog-con" :class="{'m-dialog-con' : isDesMobile}">
          <!--<el-tabs v-model="homeName" @tab-click="changeNav">
            <el-tab-pane name="first" :label="$t('lang.参展商登录')"></el-tab-pane>
            <el-tab-pane name="second" :label="$t('lang.采购商登录')"></el-tab-pane>
          </el-tabs>-->
          <div class="flex flex-c tabList" style="padding-top: 20px;padding-bottom: 25px;">
            <div class="tabitem " :class="[typeLogin==0?'active':'']" @click="()=>changeNav({index:0})">{{$t('lang.参展商登录')}}
            </div>
            <div class="tabitem " :class="[typeLogin==1?'active':'']" @click="()=>changeNav({index:1})">{{$t('lang.专业观众登录')}}
            </div>
          </div>
          <div class="login-con">
            <div class="admin-border" v-if="(typeLogin == 0 && lang == 'zh') || (typeLogin == 0 && lang == 'en')">
              <div class="regItem">
                <i class="iconfont icon-yonghu"></i>
                <!--                                <img class="icon" src="@match/assets/images/icon-yonghu.png" alt="账号"/>-->
              </div>
              <input v-model="userName" type="text" name="userName" autocomplete="off" :placeholder="$t('lang.请输入账号')" />
            </div>
            <div class="admin-border" v-if="typeLogin == 1 && lang == 'zh'">
              <div class="regItem">
                <i class="iconfont icon-yonghu"></i>
                <!--                                <img class="icon" src="@match/assets/images/icon-yonghu.png" alt="账号"/>-->
              </div>
              <input v-model="userName" autocomplete="off" type="text" name="userName" :placeholder="$t('lang.请输入手机号')" />
            </div>
            <div class="admin-border" v-if="typeLogin == 1 && lang == 'en'">
              <div class="regItem">
                <i class="iconfont icon-yonghu"></i>
                <!--                                <img class="icon" src="@match/assets/images/icon-yonghu.png" alt="账号"/>-->
              </div>
              <input v-model="userName" type="text" autocomplete="off" name="userName" :placeholder="$t('lang.请输入邮箱')" />
            </div>
            <div class="admin-border" v-if="(typeLogin == 0 && lang == 'zh')||(typeLogin == 0 && lang == 'en')">
              <div class="regItem">
                <i class="iconfont icon-mima"></i>
                <!--                                <img class="icon" src="@match/assets/images/icon_mima.png" alt="密码"/>-->
              </div>
              <input v-model="password" autocomplete="off" type="password" name="password" :placeholder="$t('lang.请输入密码')" />
            </div>
            <div class="admin-gift clearfix margin-bottom-20">
              <div class="admin-code clearfix">
                <div class="regItem">
                  <i class="iconfont icon-yanzhengma2"></i>
                  <!--                                    <img class="icon" src="@match/assets/images/icon_yanzheng.png" alt="验证码"/>-->
                </div>
                <input v-model="code" autocomplete="off" type="text" name="code" :placeholder="$t('lang.请输入验证码')" />
              </div>
              <a @click="changCodeImg()" href="javascript:void(0);" class="flex-c-c">
                <!--                            <img class="leaf" :src="validateCode" alt="验证码"/>-->
                <img class="leaf" :src="validateCode" alt="验证码" />
              </a>
            </div>

            <div class="admin-phone clearfix" v-if="typeLogin == 1 && lang == 'zh'">
              <div class="admin-code clearfix">
                <div class="regItem">
                  <i class="iconfont icon-mima"></i>
                  <!--                                    <img class="icon" src="@match/assets/images/icon_mima.png" alt="密码"/>-->
                </div>
                <input autocomplete="off" v-model="password" type="text" name="password" :placeholder="$t('lang.请输入手机验证码')" />
              </div>
              <el-button v-if="phoned" class="queryCode" :loading="loadingMobileCode" @click="queryPhoneCode()" type="primary">{{$t('lang.获取验证码')}}
              </el-button>
              <el-button v-if="!phoned" class="queryCode">{{ timer }}s</el-button>
            </div>
            <div class="admin-phone clearfix" v-if="typeLogin == 1 && lang == 'en'">
              <div class="admin-code clearfix">
                <div class="regItem">
                  <i class="iconfont icon-mima"></i>
                  <!--                                    <img class="icon" src="@match/assets/images/icon_mima.png" alt="密码"/>-->
                </div>
                <input v-model="password" type="text" name="password" autocomplete="off" :placeholder="$t('lang.请输入邮箱验证码')" />
              </div>
              <el-button v-if="phoned" class="queryCode" @click="queryEmailCode()" type="primary">{{$t('lang.获取邮箱验证码')}}
              </el-button>
              <el-button v-if="!phoned" class="queryCode">{{ timer }}s</el-button>
            </div>

          </div>
        </div>
        <div class="login_set" v-if="homeName!='second'">
          <el-checkbox-group v-model="checkList" :class="{'flex' : isDesMobile}">
            <el-checkbox class="autoLeft" :label="$t('lang.记住密码')"></el-checkbox>
            <el-checkbox class="autoRight" :label="$t('lang.自动登录')"></el-checkbox>
          </el-checkbox-group>
        </div>
        <div class="admin-btn">
          <el-button class="buttonSave" @click="cancel()">{{$t('lang.取消')}}</el-button>
          <el-button class="buttonSave" @click="login()" :loading="loginloading" type="primary">
            {{$t('lang.确定')}}
          </el-button>
        </div>
        <template v-if="!isDesMobile">
          <div v-if="typeLogin == 1&&lang == 'zh'" class="register">
            {{$t('lang.如您未注册请您先')}}<a style="color:#FF2D30;text-decoration:none;" class="link" :href="registerLink" target="_blank">{{$t('lang.注册')}}</a>
          </div>
          <div v-if="typeLogin == 1&&lang == 'en'" class="register">
            {{$t('lang.如您未注册请您先')}}<a style="color:#FF2D30;text-decoration:none;" class="link" :href="registerLink" target="_blank">{{$t('lang.注册')}}</a>
          </div>
        </template>
        <template v-if="isDesMobile">
          <div v-if="typeLogin == 1&&lang == 'zh'" class="register">
            {{$t('lang.如您未注册请您先')}}<a style="color:#FF2D30;text-decoration:none;" class="link" :href="registerLink" target="_blank">{{$t('lang.注册')}}</a>
          </div>
          <div v-if="typeLogin == 1&&lang == 'en'" class="register">
            {{$t('lang.如您未注册请您先')}}<a style="color:#FF2D30;text-decoration:none;" class="link" :href="registerLink" target="_blank">{{$t('lang.注册')}}</a>
          </div>
        </template>
      </div>
    </el-dialog>

  </div>

</template>
<script>
import { getGifCode, login, ajaxPurchaserlogin,getMobileCode, getMailCode } from "@common/api";
import { isMobile, isEmail } from "@common/utils";
import myalert from "@common/utils/myalert";
import ajax from "@common/utils/ajax";
import findComponentUpward from "@common/utils/vueFindComponent/findComponentUpward";
import messageStoreMixin from "@match/store/message/messageStoreMixin";
import { loginIM } from "./loginIM";
import { type_src_purchaser, type_src_supplier } from "@common/constact";
import { setCookie } from "@common/utils";
import { mapGetters } from "vuex";
import { getQuery, getUrlParamNative } from "@common/utils/routerUtil";
import { apiUrl } from '@common/utils/ajax'
import { getLoginUser } from "@common/utils";
import { getProjectId } from "@common/utils";
import { close_visibleLogin } from "../../pages/index/store/stateUtil";

export default {
  name: "loginDialog",
  props: {
    visible: { type: Boolean }
  },
  components: {
    alertPromise: () => import("../alertPromise")
  },
  mixins: [messageStoreMixin],
  data() {
    return {
      alertPromiseShow: false,
      loginloading: false,
      loadingMobileCode: false,
      userName: "",
      projectId: "",
      password: "",
      code: "",
      validateCode: '',
      homeName: "first",
      typeLogin: "0",
      lang: sessionStorage.getItem("lang") || 'zh',
      phoned: true,
      timer: 60,
      checkList: [],
      timestamp: new Date().getTime(),
      loginWidth: '400px',
      apiUrl: apiUrl,
      pcLink: {},
      mobileLink: {},
      registerLink: "/user/yiwu/purchaser/register"
    };
  },
  computed: {
    ...mapGetters("mobile", ["isDesMobile"]),
    isAgreement() {
      return this.$store.state.promiseAlert.isAgreement
    },
  },
  created() {
  },
  mounted() {
    this.homeName = getQuery("homeName") || 'first'
    this.projectId = this.$route.query.projectId;
    this.lang = sessionStorage.getItem("lang") || 'zh';
    sessionStorage.setItem("userType", this.typeLogin);
    this.changCodeImg()
    this.loginWidth = this.isDesMobile ? '90%' : '400px'
    console.log(this.lang)
  },
  watch: {
    validateCode(val, newval) {
    }
  },
  methods: {
    changeNav(tab, index) {
      if (tab.index == 0) {
        this.typeLogin = tab.index; // 获取模板
      } else if (tab.index == 1) {
        this.typeLogin = tab.index;
      }
      sessionStorage.setItem("userType", tab.index);
    },
    // 更换验证码图片
    changCodeImg() {
      var d = new Date()
      var time = d.getTime()
      this.validateCode = this.apiUrl + '/v1/getGifCode?timestamp=' + time
    },
    //60s倒计时
    handleClick() {
      this.phoned = !this.phoned      //点击button改变v-show的状态
      let auth_timer = setInterval(() => {  //定时器设置每秒递减
        this.timer--;        //递减时间
        if (this.timer <= 0) {
          this.phoned = !this.phoned    //60s时间结束还原v-show状态并清除定时器
          clearInterval(auth_timer)
          this.timer = 60
        }
      }, 1000)
    },
    // 获取邮箱验证码
    queryEmailCode() {
      if (!this.userName) {
        this.$message({
          message: '请输入邮箱！',
          type: 'error'
        })
        return false
      } else {
        let vals = isEmail(this.userName)
        if (!vals) {
          this.$message({
            message: '请输入正确的邮箱！',
            type: 'error'
          })
          return false
        }
      }
      let params = {
        mail: this.userName,
      }
      getMailCode(params).then(res => {
        if (res.code == 0) {
          this.handleClick()
        } else {
          this.$message({
            message: '查询失败，请重试！',
            type: 'error'
          })
        }
      })
    },
    // 获取手机号验证码
    queryPhoneCode() {
      if (!this.code) {
        myalert.fail(this.$t('lang.请先输入图片验证码'))
        return false
      }
      if (!this.userName) {
        this.$message({
          message: '请输入手机号！',
          type: 'error'
        })
        return false
      } else {
        let vals = isMobile(this.userName)
        if (!vals) {
          this.$message({
            message: '请输入正确的手机号！',
            type: 'error'
          })
          return false
        }
      }
      let params = {
        mobile: this.userName,
        vcode: this.code,
      }
      this.loadingMobileCode = true
      getMobileCode(params).then(res => {
        this.loadingMobileCode = false
        if (res.code == 0) {
          this.handleClick()
        } else {
          this.$message({
            message: res.message || '查询失败，请重试！',
            type: 'error'
          })
        }
      }).catch(e => {
        this.loadingMobileCode = false
      })
    },
    //登录
    login() {
      if (!this.projectId) {
        this.$message({
          message: ' url路径没有带projectId！',
          type: 'error'
        })
        return false
      }
      if (!this.userName) {
        this.$message({
          message: '请输入账号！',
          type: 'error'
        })
        return false
      }
      if (!this.password) {
        this.$message({
          message: '请输入手机验证码！',
          type: 'error'
        })
        return false
      }
      if (!this.code) {
        this.$message({
          message: '请输入图片验证码！',
          type: 'error'
        })
        return false
      }
      if (this.typeLogin == 0) {
        //参展中英文登录
        this.savelogin()
      } else if (this.typeLogin == 1) {
        //采购中英文登录
        this.purchaserlogin()
      }
    },
    afterLogin(loginResult) {
      var self = this
      var user2 = loginResult.user2
      var user2src = loginResult.user2src
      if (!user2) return false
      const paramsUser = {
        ...user2,
        user2src: user2src,//采购商 还是 供应商
        projectId: window._vm.$route.query.projectId
      }
      this.set_currentUser(paramsUser)
      sessionStorage.setItem("login", 'true')
      setCookie("user2", JSON.stringify(paramsUser))
      setCookie("token", loginResult && loginResult.data && loginResult.data.token)
      var $navHeader = findComponentUpward(this, 'navHeader')
      $navHeader && $navHeader.closeLoginDialog && $navHeader.closeLoginDialog()
      self.$bus && self.$bus.$emit && self.$bus.$emit('finishLogin')
      //通讯消息登录
      loginIM(user2.id)
    },
    savelogin() {
      //src 0参展商  1采购商
      let params = {
        projectId: this.projectId,
        userName: this.userName,
        password: this.password,
        src: this.typeLogin,
        vcode: this.code
      }
      let self = this
      this.loginloading = true
      login(params).then(res => {
        // 小程序
        console.log('登陆之后', res);
        this.loginloading = false
        if (res.code == 0) {
          myalert.success(this.$t('lang.登录成功'))
          if (!res.user2src) {
            res.user2src = type_src_supplier
          }
          self.afterLogin(res)
          self.redirectEvent()
          return false
        } else {
          this.$message({
            type: 'error',
            message: res.message
          })
          // this.changCodeImg()
        }
      }).catch(e => {
        console.error('e', e);
        this.loginloading = false
        // this.changCodeImg()
      })
    },
    purchaserlogin() {
      var self = this
      if (this.lang == 'zh') {
        var type = "mobile"
      } else {
        var type = "mail"
      }
      //src 0参展商  1采购商
      let params = {
        projectId: this.projectId,
        userName: this.userName,
        password: this.password,
        src: this.typeLogin,
        vcode: this.code,
        type: type
      }
      this.loginloading = true
      ajaxPurchaserlogin(params).then(res => {
        this.loginloading = false
        if (res.code == 0) {
          if (!res.user2src) {
            res.user2src = type_src_supplier
          }
          self.afterLogin(res)
          self.redirectEvent()
          myalert.success(this.$t('lang.登录成功'))
        } else {
          this.changCodeImg()
          if ("验证码错误！" == res && res.message) {
            this.$message({
              type: 'error',
              message: this.$t('lang.验证码错误！')
            })
          } else {
            this.$message({
              type: 'error',
              message: res.message
            })
          }

        }
      }).catch(e => {
        // this.changCodeImg()
        this.loginloading = false
      })
    },
    redirectEvent() {
      let self = this
      setTimeout(() => {
        /*跳转界面*/
        if (location.href.indexOf("/liveshow/detail") >= 0) {
          location.reload()
          return false
        }
        var redirect = getUrlParamNative("redirect")
        var user = getLoginUser()
        var user2src = user.user2src
        if (user2src == type_src_supplier) {
          if (redirect) {
            location.href = decodeURIComponent(redirect)
            return false
          }
          self.$router.push({
            path: `/user/yiwu/exhibition/index`,
            query: {
              projectId: this.projectId
            }
          })
          location.reload()
          return false
        }
        if (user2src == type_src_purchaser) {
          if (redirect) {
            location.href = decodeURIComponent(redirect)
            return false
          }
          self.$router.push({
            path: `/user/yiwu/purchaser/index`,
            query: {
              projectId: this.projectId
            }
          })
          location.reload()
          return false
        }

        return false
      }, 1000)
    },            //取消
    cancel() {
      this.$emit('update:visible', false)
      var $navHeader = findComponentUpward(this, 'navHeader')
      $navHeader && $navHeader.closeLoginDialog && $navHeader.closeLoginDialog();
      close_visibleLogin()
    },

    async getConversationList() {
      var a = await window.tim.getConversationList()
      return a && a.data && a.data.conversationList;
    },

    onUpdateConversationList({ }) {
    },
    onError({ data }) {
      if (data.message !== "Network Error") {
        console.log("=====onError===>", data.message);
      }
    }
  }
};
</script>
<style scoped lang="less">
@import '../../styles/color.less';

.login-con {
  margin-top: 15px;
}

.login-con .admin-border {
  margin-bottom: 20px;
}

.login-con .admin-border {
  width: 98%;
  display: flex;
}

.login-con .admin-gift {
  width: 100%;
  position: relative;
  display: flex;
}

.login-con .admin-phone {
  width: 100%;
  position: relative;
  display: flex;
  margin-bottom: 20px;
}

.login-con .admin-border input {
  border: none;
  background: rgba(249, 249, 249, 1);
  padding-left: 2%;
  height: 38px;
  width: 86%;
  display: inline-block;
}

.login-con .admin-phone .admin-code {
  width: 57%;
  height: 40px;
  line-height: 40px;
  background: rgba(249, 249, 249, 1);
  border: 1px solid rgba(237, 237, 237, 1);
  border-radius: 4px;
  display: flex;
}

.login-con .admin-gift .admin-code {
  width: 57%;
  height: 40px;
  line-height: 40px;
  background: rgba(249, 249, 249, 1);
  border: 1px solid rgba(237, 237, 237, 1);
  border-radius: 4px;
  display: flex;
}

.login-con .admin-code input {
  border: none;
  background: rgba(249, 249, 249, 1);
  padding-left: 3%;
  height: 38px;
  width: 75%;
  display: inline-block;
}

.login-con .admin-gift .leaf {
  position: absolute;
  top: 5px;
  right: 0;
}

.login-con .admin-phone .queryCode {
  position: absolute;
  top: 5px;
  right: 0;
}

.dialog-login .admin-btn {
  width: 100%;
  text-align: center;
  margin: 5px auto;
}

.dialog-login .buttonSave {
  width: 40% !important;
  height: 40px;
  font-size: 14px;
}

.login_set {
  margin-top: 20px;
  margin-bottom: 20px;
}

.login_set .autoLeft {
  width: 45%;
  text-align: left;
}

.login_set .autoRight {
  width: 45%;
  text-align: right;
}

.admin-border {
  width: 100%;
  height: 40px;
  line-height: 40px;
  background: rgba(249, 249, 249, 1);
  border: 1px solid rgba(237, 237, 237, 1);
  border-radius: 4px;
}

.regItem {
  width: 35px;
  border-right: 1px solid rgba(237, 237, 237, 1);
  height: 40px;
  display: flex;
  justify-content: center; /*在主轴上的对齐*/
  align-items: center; /*在交叉轴上中心点的对齐*/
}

.m-login-con input,
.m-dialog-con input {
  font-size: 14px !important;
  box-sizing: border-box !important;
}

.register {
  font-size: 12px;
  margin-top: 15px;
  text-align: center;
}

/deep/ .dialog-login {
  min-height: 320px;
}

/deep/ .el-dialog__header {
  display: none;
}

/deep/ .el-dialog__body {
  padding-top: 10px;
}

/deep/ .el-tabs.el-tabs--top {
  display: flex;
  justify-content: center;
}

/deep/ .el-tabs__header.is-top {
  display: flex;
  justify-content: center;
  width: 100%;
}

/deep/ .el-tabs__nav-wrap.is-top {
  display: flex;
  justify-content: center;
  width: 100%;
}

/deep/ .el-tabs__nav-scroll {
}

.tabList {
  display: flex;
  justify-content: space-around;
  position: relative;
  &:after {
    position: absolute;
    content: '';
    width: 100%;
    height: 1px;
    background: #ddd;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
  }
}

.tabList .tabitem {
  position: relative;
  cursor: pointer;
}

.tabList .tabitem.active:after {
  position: absolute;
  content: '';
  width: 80%;
  height: 2px;
  background: @primaryColor;
  bottom: -15px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 888;
}
</style>



// WEBPACK FOOTER //
// src/match/components/login/loginDialog.vue